// ---------------------------------------------------------------------------
// Lucide-icon rows for the /product branch, derived from the canonical
// PRODUCT_STAGES spine (product-stages.ts) so a mobile-nav row and a stage
// page can never describe the same page differently. The desktop popover no
// longer renders these (it uses the card-in-card stage grid); the consumer
// left is the mobile drawer's icon rows.
// ---------------------------------------------------------------------------

import {
	Bot,
	Cable,
	LayoutGrid,
	Brain,
	MessagesSquare,
	Mic,
	type LucideIcon,
} from 'lucide-react';

import { INTEGRATIONS_CELL, PRODUCT_STAGES } from './product-stages';

export interface ProductLink {
	/** Registry slug; the href is always `/product/<slug>`. */
	slug: string;
	label: string;
	/** One line, popover-row length. */
	description: string;
	icon: LucideIcon;
}

/** The one icon per stage slug - shared by the nav rows and the landing ledger. */
export const STAGE_ICONS: Record<string, LucideIcon> = {
	chat: MessagesSquare,
	meetings: Mic,
	memory: Brain,
	agents: Bot,
	views: LayoutGrid,
};

/** The five stage pages + the integrations directory, in spine order. */
export const PRODUCT_FEATURE_LINKS: readonly ProductLink[] = [
	...PRODUCT_STAGES.map((stage) => ({
		slug: stage.slug,
		label: stage.label,
		description: stage.benefit,
		icon: STAGE_ICONS[stage.slug] ?? MessagesSquare,
	})),
	{
		slug: 'integrations',
		label: INTEGRATIONS_CELL.label,
		description: INTEGRATIONS_CELL.benefit,
		icon: Cable,
	},
];

export const productHref = (link: ProductLink): string => `/product/${link.slug}`;
